import React from 'react';
import { useSelector } from "react-redux";
import {
  CRow,
  CCol,
  CLabel,
  CInput,
} from "@coreui/react";

const Fax = (props) => {
  const { handleInputChange } = props;
  const { insert, main } = useSelector((state) => state);

  return (
    <>
      <CRow>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>개인FAX번호(없을 시 없음기재)
          </CLabel>
          <CInput
            type="text"
            id="faxNo"
            name="faxNo"
            value={insert.reqTaskInfo.faxNo || ""}
            maxLength="20"
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          />
        </CCol>
      </CRow>
    </>
  )
}

export default React.memo(Fax);